import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import {
  CollectorListItem,
  CollectorsConfig
} from '../../../domain/collector-profile.model';

@Component({
  selector: 'app-collector-editable-profile-card',
  templateUrl: './collector-editable-profile-card.component.html',
  styleUrls: ['../collector-card.shared.css']
})
export class CollectorEditableProfileCardComponent implements OnChanges {
  @Input() collector!: CollectorListItem;
  @Input() config!: CollectorsConfig;
  @Input() readOnly = false;
  @Output() change = new EventEmitter<void>();

  filteredTeamOptions: string[] = [];
  filteredRoleOptions: string[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.config) {
      this.showAllTeamOptions();
      this.showAllRoleOptions();
    }
  }

  onTeamChanged(value: string): void {
    this.filteredTeamOptions = this.filterOptions(
      this.config?.teamOptions,
      value
    );
    this.emitChange();
  }

  onRoleChanged(value: string): void {
    this.filteredRoleOptions = this.filterOptions(
      this.config?.roleOptions,
      value
    );
    this.emitChange();
  }

  showAllTeamOptions(): void {
    this.filteredTeamOptions = [...(this.config?.teamOptions ?? [])];
  }

  showAllRoleOptions(): void {
    this.filteredRoleOptions = [...(this.config?.roleOptions ?? [])];
  }

  openTeamOptions(
    input: HTMLInputElement,
    trigger: MatAutocompleteTrigger
  ): void {
    this.showAllTeamOptions();
    input.focus();
    trigger.openPanel();
  }

  openRoleOptions(
    input: HTMLInputElement,
    trigger: MatAutocompleteTrigger
  ): void {
    this.showAllRoleOptions();
    input.focus();
    trigger.openPanel();
  }

  emitChange(): void {
    if (!this.readOnly) {
      this.change.emit();
    }
  }

  private filterOptions(options: string[] | undefined, value: string): string[] {
    const normalizedValue = (value ?? '').trim().toLocaleLowerCase();
    if (!normalizedValue) {
      return [...(options ?? [])];
    }
    return (options ?? []).filter((option) =>
      option.toLocaleLowerCase().includes(normalizedValue)
    );
  }
}
